import { render, staticRenderFns } from "./NutritionForm.vue?vue&type=template&id=0d949e3c&scoped=true"
import script from "./NutritionForm.vue?vue&type=script&lang=ts"
export * from "./NutritionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d949e3c",
  null
  
)

export default component.exports